<h2 mat-dialog-title>Are you sure you want to delete this?</h2>
<mat-dialog-content>
    It will not be recoverable.
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Delete</button>  
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>